import { h } from "preact";
import { useState, useRef, useEffect } from "preact/hooks";
import { LuShare2 } from "react-icons/lu";
import { MdOutlineVerified } from "react-icons/md";
import { FiSend } from "react-icons/fi";

const CredentialShare = ({
  socialMediaShare,
  isVerifying,
  onVerify,
  credentialId,
}) => {
  const [showShareMenu, setShowShareMenu] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowShareMenu(false);
      }
    };

    if (showShareMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showShareMenu]);

  return (
    <div class="flex flex-col gap-4">
      <p class="text-lg py-0 md:pb-0">COMPARTIR EN:</p>
      <article class="w-full rounded-lg bg-[#FFF] p-2 my-0 md:py-0 md:mt-0 lg:mb-0 md:h-[120px] lg:h-[65px] flex items-center">
        <div class="w-full my-3 grid grid-cols-2 gap-4 items-center lg:flex lg:flex-nowrap">
          <button
            onClick={socialMediaShare("linkedin_certification")}
            rel="noopener noreferrer"
            class="w-full text-sm md:text-md h-[40px] rounded-md border border-[#0a66c2] border-solid bg-[#0a66c2] text-white flex justify-center items-center hover:bg-[#004182] transition-colors lg:w-[155px]"
          >
            <img
              class="w-[20px] h-[20px] mr-2"
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/icon_LI_2Cer.png"
              alt="Linkedin"
            />
            <span class="leading-tight text-left">Agregar a perfil</span>
          </button>
          <button
            onClick={socialMediaShare("linkedin_post")}
            class="w-full text-sm md:text-md h-[40px] flex justify-center items-center rounded-md border border-[#0a66c2] border-solid bg-white text-[#0a66c2] hover:bg-[#F5F8FC] transition-colors lg:w-[140px]"
          >
            <img
              class="w-[20px] h-[20px] mr-2"
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/icon_LI_1Cer.png"
              alt="post Linkedin"
            />
            <span class="leading-tight text-left">Publicar post</span>
          </button>

          <div class="relative w-full lg:w-auto lg:ml-auto">
            <button
              ref={buttonRef}
              onClick={() => setShowShareMenu(!showShareMenu)}
              class="w-full h-[40px] px-4 lg:px-1 flex justify-center items-center rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-[#EFF2F5] transition-colors lg:w-[135px]"
            >
              <FiSend class="w-[20px] h-[20px] mr-2 shrink-0" />
              <span>Compartir</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class={`ml-2 transition-transform shrink-0 ${showShareMenu ? "rotate-180" : ""}`}
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </button>

            {showShareMenu && (
              <div
                ref={menuRef}
                class="absolute left-0 top-full mt-2 w-[90vw] z-50 md:w-64 md:right-0 md:left-auto bg-white rounded-lg shadow-xl border border-gray-100 overflow-hidden text-left"
              >
                <div class="p-3">
                  <p class="text-xs font-semibold text-gray-500 mb-2 px-2">
                    REDES SOCIALES
                  </p>
                  <div class="grid grid-cols-3 gap-2 md:block">
                    <button
                      onClick={socialMediaShare("facebook")}
                      class="w-full flex flex-col items-center justify-center md:flex-row md:justify-start px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md"
                    >
                      <img
                        class="w-[40px] h-[40px] mb-1 md:mb-0 md:w-5 md:h-5 md:mr-3"
                        src="https://d1g6c01s9ssd7h.cloudfront.net/img/icon_FaceBCer.png"
                        alt="Facebook"
                      />
                      <span class="text-[10px] text-[#616161] md:text-sm text-center md:text-left">
                        Facebook
                      </span>
                    </button>
                    <button
                      onClick={socialMediaShare("whatsapp")}
                      class="w-full flex flex-col items-center justify-center md:flex-row md:justify-start px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md"
                    >
                      <img
                        class="w-[40px] h-[40px] mb-1 md:mb-0 md:w-5 md:h-5 md:mr-3"
                        src="https://d1g6c01s9ssd7h.cloudfront.net/img/icon_WhatsACer.png"
                        alt="WhatsApp"
                      />
                      <span class="text-[10px] text-[#616161] md:text-sm text-center md:text-left">
                        WhatsApp
                      </span>
                    </button>
                    <button
                      onClick={socialMediaShare("twitter")}
                      class="w-full flex flex-col items-center justify-center md:flex-row md:justify-start px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md"
                    >
                      <img
                        class="w-[40px] h-[40px] mb-1 md:mb-0 md:w-5 md:h-5 md:mr-3"
                        src="https://d1g6c01s9ssd7h.cloudfront.net/img/icon_XCer.png"
                        alt="X"
                      />
                      <span class="text-[10px] text-[#616161] md:text-sm text-center md:text-left">
                        X (Twitter)
                      </span>
                    </button>
                  </div>
                </div>
                <div class="h-px bg-gray-100 mx-3"></div>
                <div class="p-3">
                  <p class="text-xs font-semibold text-gray-500 mb-2 px-2">
                    OTRAS OPCIONES
                  </p>
                  <div class="grid grid-cols-3 gap-2 md:block">
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(credentialId);
                        socialMediaShare("copy_urld")();
                        setShowShareMenu(false);
                      }}
                      class="w-full flex flex-col items-center justify-center md:flex-row md:justify-start px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md"
                    >
                      <img
                        class="w-[40px] h-[40px] mb-1 md:mb-0 md:w-5 md:h-5 md:mr-3"
                        src="https://d1g6c01s9ssd7h.cloudfront.net/img/icon_linkCer.png"
                        alt="Copy Link"
                      />
                      <span class="text-[10px] text-[#616161] md:text-sm text-center md:text-left">
                        Copiar enlace
                      </span>
                    </button>
                    <button
                      onClick={socialMediaShare("email")}
                      class="w-full flex flex-col items-center justify-center md:flex-row md:justify-start px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md"
                    >
                      <img
                        class="w-[40px] h-[40px] mb-1 md:mb-0 md:w-5 md:h-5 md:mr-3"
                        src="https://d1g6c01s9ssd7h.cloudfront.net/img/icon_MailCer.png"
                        alt="Email"
                      />
                      <span class="text-[10px] text-[#616161] md:text-sm text-center md:text-left">
                        Enviar por email
                      </span>
                    </button>
                    <button
                      onClick={socialMediaShare("download")}
                      class="w-full flex flex-col items-center justify-center md:flex-row md:justify-start px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md"
                    >
                      <img
                        class="w-[40px] h-[40px] mb-1 md:mb-0 md:w-5 md:h-5 md:mr-3"
                        src="https://d1g6c01s9ssd7h.cloudfront.net/img/icon_DescargarCer.png"
                        alt="Download"
                      />
                      <span class="text-[10px] text-[#616161] md:text-sm text-center md:text-left">
                        Descargar
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <button
            onClick={() => {
              onVerify();
            }}
            disabled={isVerifying}
            class={`w-full h-[40px] px-4 lg:px-1 flex items-center justify-center text-white font-medium rounded-md border border-[#008751] shadow-sm bg-[#008751] hover:bg-[#1C9A61] transition-colors lg:w-[105px] ${
              isVerifying ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            <MdOutlineVerified class="w-[20px] h-[20px] mr-2 shrink-0" />
            Verificar
          </button>
        </div>
      </article>
    </div>
  );
};

export default CredentialShare;
